import React from 'react';
const BackgroundCheckSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-background-check" });
BackgroundCheckSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-background-check sirius-icon-background-check-enhance" });
export default BackgroundCheckSvg;
